import { datadogLogs, type LogsEvent } from '@datadog/browser-logs';

import { isDev } from '#configuration/env.ts';
import { isLocalhost } from '#utils/isLocalhost.ts';

const QUERY_PARAMS_TO_REDACT = ['access_token', 'id_token', 'code', 'apiKey'];

export const logDataToDatadog = (message: string) => {
    if (isDev) {
        console.info('logDataToDatadog:', message);
    }
    if (!isLocalhost()) {
        datadogLogs.logger.log(`${message}`);
    }
};

const isUnwantedRequestLog = (event: LogsEvent): boolean => {
    return (
        !!event?.http?.url.includes('api.here.com') ||
        !!event?.http?.url.includes('maps.hereapi.com') ||
        !!event?.http?.url.includes('vector.hereapi.com') ||
        !!event?.http?.url.includes('router.hereapi.com') ||
        !!event?.http?.url.includes('cdn.rio.cloud') ||
        !!event?.http?.url.includes('cdn-eu.configcat.com') ||
        !!event?.http?.url.includes('ad.doubleclick.net') ||
        !!event?.message.includes('ConfigCat - ERROR - [1103]')
    );
};

const getMessagePrefix = (event: LogsEvent): string => {
    switch (event.origin) {
        case 'network':
            return 'NETWORK | ';
        case 'console':
            return 'CONSOLE | ';
        case 'logger':
            return 'LOGGER | ';
        default:
            return '';
    }
};
const formatMessage = (event: LogsEvent) => {
    const prefix = getMessagePrefix(event);
    event.message = `ORDERCOM | ${prefix}${event.message}`;
    return event;
};

const redactLogEvent = (event: LogsEvent) => {
    QUERY_PARAMS_TO_REDACT.forEach(param => {
        const regex = new RegExp(`${param}=[^&]*`, 'g');
        event.view.url = event.view.url.replace(regex, `${param}=REDACTED`);
        event.view.referrer = event.view.referrer?.replace(regex, `${param}=REDACTED`);
        event.message = event.message?.replace(regex, `${param}=REDACTED`);
        if (event.error?.stack) {
            event.error.stack = event.error.stack.replace(regex, `${param}=REDACTED`);
        }
        if (event.http?.url) {
            event.http.url = event.http.url.replace(regex, `${param}=REDACTED`);
        }
    });
    event.message = formatMessage(event).message;
    return true;
};

export const cleanLogs = (event: LogsEvent) => {
    if (isUnwantedRequestLog(event)) {
        return false;
    }
    return redactLogEvent(event);
};
